define('Hack.Shopping', [
    'SC.Configuration',
    'ProductDetails.Base.View',
    'underscore',

    'Hack.Common'
],
function HackShopping(
    Configuration,
    ProductDetailsBaseView,
    _
) {
    'use strict';

    ProductDetailsBaseView.optionBindEventByType = _(ProductDetailsBaseView.optionBindEventByType || {}).extend({
        'checkbox': 'click'
    });

    return {
        mountToApp: function mountToApp(container) {
            var LayoutComponent = container.getComponent('Layout');
            var giftWrapItem = Configuration.get('customizations.giftWrap.giftWrapItem', []);
            LayoutComponent.addToViewContextDefinition('Header.MiniCartItemCell.View', 'linkAttributes', 'string', function linkAttr(context) {
                if (context && context.line && context.line.item.internalid === parseInt(SC.ENVIRONMENT.published.monogramItemId, 10)) {
                    return '';
                }
                if (context && context.line && context.line.item.internalid === parseInt(giftWrapItem, 10)) {
                    return '';
                }
                return context.linkAttributes;
            });
        }
    };
});

